import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "react-toggle/style.css";
import FieldText from "../Fields/FieldText";
import AlertComponent from "../AlertComponent";

function AddOrEditRmtpOutput(props) {
  const { outputName, handleAddNewElementsOutput, currentElement } = props;

  const [destinationUrl, setDestinationUrl] = useState(null);
  const [streamingKey, setStreamingKey] = useState(null);

  const handleAddItem = () => {
    if (!outputName) {
      return AlertComponent("Error", "Output name is required", {
        icon: `error`,
      });
    }

    if (!destinationUrl) {
      return AlertComponent("Error", "Destination URL is required", {
        icon: `error`,
      });
    }

    if (!streamingKey) {
      return AlertComponent("Error", "Streaming Key is required", {
        icon: `error`,
      });
    }

    const item = {
      name: outputName,
      outputType: `RTMP`,
      destinationUrl: destinationUrl,
      streamingKey: streamingKey,
    };

    if (currentElement) {
      item.id = currentElement.id;
    }

    handleAddNewElementsOutput(item);
  };

  useEffect(() => {
    if (currentElement) {
      setDestinationUrl(currentElement.destinationUrl);
      setStreamingKey(currentElement.streamingKey);
    }
  }, [currentElement]);

  return (
    <div>
      <FieldText
        label="Destination URL"
        type="text"
        onChange={(x) => setDestinationUrl(x.target.value)}
        placeholder="e.g: rtmps://live-api-s.facebook.com:443/rtmp/ or rtmp://00.000.000.000:1935/livestream"
        value={destinationUrl}
        className="col-md-12"
        required={true}
        inputClassName={`inputOption`}
      />

      <FieldText
        label="Streaming Key / Stream Name"
        type="text"
        onChange={(x) => setStreamingKey(x.target.value)}
        placeholder="e.g: FB-000000000111112323212-0-Abzi127lHnk3AMVe or livestream-instance"
        value={streamingKey}
        className="col-md-12"
        required={true}
        inputClassName={`inputOption`}
      />

      <Button className="dark-btn" onClick={handleAddItem}>
        Add
      </Button>
    </div>
  );
}

export default AddOrEditRmtpOutput;
